import { AnnouncerKey } from "@/helpers/types";

class LiveAnnouncerService {
  private containers: Record<string, HTMLElement> = {};
  private toggle: 0 | 1 = 0;

  initWithElement(key: AnnouncerKey, el: HTMLElement) {
    if (!el || !(el instanceof HTMLElement)) {
      console.warn("Invalid element provided");
      return;
    }
    this.containers[key] = el;
    const nodeEl = document.createElement("p");
    el.appendChild(nodeEl);
    this.containers[key].appendChild(nodeEl);
  }

  /**
   * Triggers a visually hidden announcement, meant only for assistive technologies.
   * @param message The message to announce.
   * @description This method allows us to communicate the AT any change in the main node.
   * The idea behind using "\u200B" or "\u200C" is to "force" the screen reader to announce the change.
   * Even if the content is the same as the previous one.
   */
  announce(key: AnnouncerKey, message: string) {
    if (!this.containers[key]) {
      console.warn("Invalid container key");
      return;
    }
    this.containers[key].lastChild.textContent =
      message + (this.toggle ? "\u200B" : "\u200C");
    this.toggle = this.toggle ? 0 : 1;
  }
}

export const useLiveAnnouncer = new LiveAnnouncerService();
